import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=5e4902f7&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"
import style0 from "./Branches.vue?vue&type=style&index=0&id=5e4902f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4902f7",
  null
  
)

export default component.exports